
import { builderDispatch } from '../_utils/ui';
import GroupedCategoryChangeEvents from './grouped-category-change-events';
import QuantityPricingTools from './quantity-pricing-tools';
import Currency from '../_utils/tools/currency';
import md5 from 'js-md5';

// -----------------------------------------------------------

builderDispatch.register((payload) => {
  switch (payload.type) {
    case GroupedCategoryChangeEvents.PAGE_LOADED:
    case GroupedCategoryChangeEvents.PRODUCT_SELECTED:
      if (typeof s_omni === 'object') {
        payload = {
          ...payload,
          productSelected: payload.type === GroupedCategoryChangeEvents.PRODUCT_SELECTED,
        };

        payload.printsItemPage
          ? (new OmniAttributesPrints(payload)).send()
          : (new OmniAttributesPrism(payload)).send();
      }
      break;
  }
});

// -----------------------------------------------------------

const PARAMETERS = [
  'pageName',
  'campaign',
  'channel',
  'prop1',
  'prop2',
  'prop3',
  'prop4',
  'prop5',
  'prop8',
  'prop21',
  'events',
  'products'
];

let lastSentHash;

class OmniAttributesBase {
  constructor({ product, deliveryOptions }) {
    this.product = product;

    this.fulfilledMethods = (product.delivery_options || [])
      .map((deliveryOptionId) =>
        deliveryOptions.find((delOpt) => delOpt.key === deliveryOptionId).analytics_id
      );
  }

  get campaign() {
    const campaign = {
      adid: s_omni.getQueryParam('adid'),
      fbref: s_omni.getQueryParam('fb_ref'),
      sourceid: s_omni.getQueryParam('sourceid'),
      get campaignId() {
        if (this.adid) { return this.adid; }
        if (this.fbref) { return this.fbref.split('_')[1]; }
        if (this.sourceid) { return this.sourceid; }
        return '';
      },
    };

    return campaign.campaignId;
  }

  get partnerId() {
    // ensure partner id has a value; revert to upc if nil
    return this.product.partner_id || this.product.code;
  }

  get channel() {
    return window.location.href;
  }

  get events() {
    const events = ['prodView', 'event1', 'event33'];

    if (this.fulfilledMethods.indexOf('PUT') === 0) {
      events.push('event29'); /* PUT = Pick Up Today */
    }

    return events.join(',');
  }

  get prop1() {
    return 'Item';
  }

  get prop4() {
    return '';
  }

  get prop8() {
    return 'Walmart Photo: LiveLink';
  }

  get prop21() {
    return this.fulfilledMethods.join(',');
  }

  get products() {
    return [
      'walmartphotocenter:',
      this.partnerId,
      this.copies,
      this.price,
      '',
      'evar30=Walmart.com'
    ].join(';');
  }

  send() {
    const payload = PARAMETERS.reduce((acc, key) => {
      acc[key] = this[key];
      return acc;
    }, {});

    // check the hash of this payload against the last one
    // return if they're the same to avoid
    // double sends.
    const payloadHash = md5(Object.values(payload).join('-'));
    if (lastSentHash === payloadHash) {
      return;
    }

    Object.assign(s_omni, payload);

    s_omni.t();

    lastSentHash = payloadHash;
  }
}

class OmniAttributesPrism extends OmniAttributesBase {
  constructor({ product, deliveryOptions, breadcrumbs, copies = 1, productSelected }) {
    super({ product, deliveryOptions });

    this.breadcrumbs = breadcrumbs || [];
    this.copies = copies;
    this.productSelected = productSelected;
  }

  get category() {
    return (this.breadcrumbs[0] || {}).name;
  }

  get price() {
    const unitPriceForQuantity = this.product.show_quantity_dropdown
      ? this.quantityPricingTools.getUnitPriceForQuantity(this.copies)
      : this.product.minimum_price; // minimum_price is in the form of, eg, 18.45

    return Currency.format(unitPriceForQuantity * this.copies, { symbol: false });
  }

  get pageName() {
    return `${this.category} [Item Page]`;
  }

  get pageTitle() {
    return (this.breadcrumbs[this.breadcrumbs.length - 1] || {}).name;
  }

  get prop2() {
    return this.productSelected
      ? `${this.product.title} Product ${this.partnerId}`
      : this.pageTitle;
  }

  get prop3() {
    return this.category;
  }

  get prop5() {
    return this.breadcrumbs.map((crumb) => crumb.name).join(': ');
  }

  get quantityPricingTools() {
    return new QuantityPricingTools(this.product);
  }
}

class OmniAttributesPrints extends OmniAttributesBase {
  get price() {
    return this.product.price / 100 || null;
  }

  get copies() {
    return 1;
  }

  get pageName() {
    return 'Prints [Item Page]';
  }

  get prop2() {
    return `${this.product.size}, ${this.product.finish} Product ${this.partnerId}`;
  }

  get prop3() {
    return 'Prints';
  }

  get prop5() {
    return 'Prints';
  }
}

// -----------------------------------------------------------

export { OmniAttributesPrism };
